import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button} from "@mui/material";
import {useTheme} from "@mui/material/styles";

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  entityName = "elemento",
  entityLabel = "",
  confirmText = "Eliminar",
  cancelText = "Cancelar",
  title = "Eliminar ",
  description
}) {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.colors.background,
          borderRadius: theme.shape.borderRadius,
          boxShadow: theme.shadows[5],
        }
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: theme.palette.sidebar.background,
          color: theme.palette.windowScreen.title,
          fontWeight: "bold",
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          mb: 2,
          px: 3,
          py: 2
        }}
      >
        {title}
        {entityName}
      </DialogTitle>
      <DialogContent
        sx={{
          px: 3,
          pb: 1,
        }}
      >
        <DialogContentText
          sx={{
            color: theme.palette.text.primary,
          }}
        >
          {description ? (
            description
          ) : (
            <>
              ¿Seguro que desea eliminar {entityName}
              {entityLabel && (
                <>
                  {" "}
                  <strong>{entityLabel}</strong>
                </>
              )}
              ? <br />
              Esta acción <strong>no se puede deshacer.</strong>
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: theme.palette.colors.primary,
            color: theme.palette.colors.white,
            "&:hover": {
              opacity: 0.85
            }
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: theme.palette.colors.secondary,
            color: theme.palette.colors.white,
            "&:hover": {
              opacity: 0.85
            }
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
